
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://escvrqjqbriebtdguirm.supabase.co'
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVzY3ZycWpxYnJpZWJ0ZGd1aXJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgxOTc2MDcsImV4cCI6MjA3Mzc3MzYwN30.9VLqkFgAtBr2ByzRM8lPAuINgBoTCgNJASQ_I5zhXyE"
const supabase = createClient(supabaseUrl, supabaseKey)
export default supabase